export default __webpack_public_path__ + "static/media/LibreBaskerville-Bold.14ee45b4.ttf";